import { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { Breadcrumbs } from '@loadsmart/loadsmart-ui'

import { parseQueryString, stringifyQueryString } from 'core/infra/queryString'

import user from 'legacy/utils/user'

import { PORTAL_LINK_SHIPMENTS_PATH } from 'rate-command-center/domain/PortalLinkRoute'

const SHIPMENTS_URL = PORTAL_LINK_SHIPMENTS_PATH

export type ShipmenDetailsBreadcrumbProps = {
  shipmentUUID: string
  shipmentTitle: string
}

export function ShipmentDetailsBreadcrumb({
  shipmentUUID,
  shipmentTitle,
}: ShipmenDetailsBreadcrumbProps) {
  const history = useHistory()
  const location = useLocation()
  const isUserLoggedIn = user.isLoggedIn()

  const handleBackToShipperLoads = useCallback(() => {
    history.push(SHIPMENTS_URL)
  }, [history])

  const breadcrumbEntries = useMemo(
    () => [
      {
        label: 'Shipments',
        url: `#${SHIPMENTS_URL}`,
      },
      { label: `Shipment #${shipmentTitle}` },
    ],
    [shipmentTitle]
  )

  function handleUnsignedClick(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    if (!isUserLoggedIn) {
      e.stopPropagation()
      e.preventDefault()

      const search = { ...parseQueryString(location.search), signup: 'true' }
      history.replace({ search: stringifyQueryString(search) })
    }
  }

  return (
    <div onClickCapture={handleUnsignedClick}>
      <Breadcrumbs onBack={handleBackToShipperLoads} entries={breadcrumbEntries} />
    </div>
  )
}
